export default "__VITE_ASSET__CzvB2bAK__"